import {
  MessageCircle,
  Heart,
  Megaphone,
  Sparkles,
  Lightbulb,
  Award,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  'message-circle': MessageCircle,
  heart: Heart,
  megaphone: Megaphone,
  sparkles: Sparkles,
  lightbulb: Lightbulb,
  award: Award,
};

export function getBadgeIcon(icon: string | null | undefined): LucideIcon {
  return (icon && ICONS[icon]) || Award;
}

/** Vent Blue — shared accent for every badge surface. */
export const BADGE_ACCENT = '#5E819D';
